import React from 'react'

export default class ModalInformarEntregaEncomendaAvulsa extends React.Component {
  constructor (props) {
    super(props)
    this.state = { nomeRecebedor: '', rg: '', cpf: '', observacao: '', erro: null }
  }

  confirmar () {
    if (!this.state.nomeRecebedor.trim()) {
      this.setState({ erro: 'Informe o nome de quem recebeu a encomenda.' })
      return
    }
    this.props.onConfirmar({
      nomeRecebedor: this.state.nomeRecebedor,
      rg: this.state.rg,
      cpf: this.state.cpf,
      observacao: this.state.observacao
    })
  }

  render () {
    const encomenda = this.props.encomenda
    return (
      <React.Fragment>
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
              <div className="vx-modal-header">
                <div className="vx-modal-title">
                  <span className="material-icons">local_shipping</span>
                  Informar entrega — OS {encomenda.numeroOs}
                </div>
                <button type="button" className="vx-modal-close" aria-label="Close" onClick={this.props.onFechar}>
                  <span className="material-icons">close</span>
                </button>
              </div>
              <div className="vx-modal-body" style={{ background: '#fff' }}>
                <div className="form-group">
                  <label>Nome de quem recebeu</label>
                  <input type="text" className="form-control" value={this.state.nomeRecebedor}
                         onChange={event => this.setState({ nomeRecebedor: event.target.value, erro: null })}/>
                  {this.state.erro && <small className="text-danger">{this.state.erro}</small>}
                </div>
                <div className="form-row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>RG</label>
                      <input type="text" className="form-control" value={this.state.rg}
                             onChange={event => this.setState({ rg: event.target.value })}/>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>CPF</label>
                      <input type="text" className="form-control" value={this.state.cpf}
                             onChange={event => this.setState({ cpf: event.target.value })}/>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <label>Observação</label>
                  <textarea className="form-control" rows="2" value={this.state.observacao}
                            onChange={event => this.setState({ observacao: event.target.value })}/>
                </div>
              </div>
              <div className="vx-modal-footer">
                <button type="button" className="vx-modal-btn-fechar" onClick={this.props.onFechar}>Cancelar</button>
                <button type="button" className="vx-modal-btn-confirmar" onClick={() => this.confirmar()}>
                  <span className="material-icons" style={{ fontSize: 15 }}>check</span>
                  Confirmar entrega
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show"/>
      </React.Fragment>
    )
  }
}
